import { SERVICE_URL } from './ServiceURL'

class RefusesService {

	constructor (resource) {
		this.store = resource.$store;
		this.http = resource.$http;
	}

	fetch (phone) {
		return new Promise((resolve, reject) => {
			this.http.get(`${SERVICE_URL}v1/refuses/`, {
				headers: {
					'x-access-token': this.store.state.user.token || ''
				}
			})
				.then(response => response.json())
				.then(refuses => resolve(refuses))
				.catch(err => {
					reject(err.body.message || err.message);
				})
		});
	}
}
export default RefusesService;


// WEBPACK FOOTER //
// ./src/service/RefusesService.js